import state from "./modulePermissionsState";
import mutations from "./modulePermissionsMutations";
import actions from "./modulePermissionsActions";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
};
